import { format, parse } from "date-fns";

/**
 *
 * @param value DD/MM/YYYY
 * @returns
 */

function formatDDMMYYYYtoISO(value: string) {
  return format(parse(value, "dd/MM/yyyy", new Date()), "yyyy-MM-dd");
}

export default formatDDMMYYYYtoISO;
